import React, { useEffect, useState } from "react";
import {
  Accordion,
  Button,
  Card,
  Col,
  DropdownButton,
  Dropdown,
  Form,
  Nav,
  Modal,
  Spinner,
  ListGroup,
  Row,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import Select from "../components/ui/AppReactSelect";
import { useDispatch, useSelector } from "react-redux";
import { MdEdit, MdDelete, MdHelpOutline } from "react-icons/md";
import { useHistory } from "react-router-dom";
import {
  fetchRetailerWholesalerSections,
  updateRetailerWholesalerSection,
  deleteRetailerWholesalerSection,
  createRetailerWholesalerSection,
  fetchRetailerWholesalers,
} from "../actions/retailerWholesalerSectionActions";
import { createRetailerWholesalerProduct } from "../actions/retailerWholesalerProductActions";
import {
  createRetailerWholesalerOption,
  fetchRetailerWholesalerOptions,
  createRetailerWholesalerOptionGroup,
  fetchRetailerWholesalerOptionGroups,
  deleteRetailerWholesalerOptionGroup,
  deleteRetailerWholesalerOption,
  updateRetailerWholesalerOption,
  updateRetailerWholesalerOptionGroup,
} from "../actions/retailerWholesalerOptionActions";
import { toast } from "react-toastify";
import { Switch } from "@material-ui/core";
import { getUserFromLocalStorage } from "../utilities/user";
import { apiSetCatalogItemStatus } from "../api";
// This file referenced `placeholderImage` in five places (product rows, the
// hover preview and the simulation grid) WITHOUT ever importing it. Every use
// is `product.image || placeholderImage`, so `||` short-circuits whenever an
// image exists — meaning the ReferenceError only fires for a product with NO
// image, and takes the whole /admin/catalog route down when it does. The
// sibling screen (Publications/BrandProductManagement.js:27) imports exactly
// this asset; matching it.
import placeholderImage from "../assets/img/menuImage.png";
import ProductSimulation from "../components/ProductSimulation";
import { useGate, Gated, GATE_TITLE } from "../components/team/Gated";
import AppSelect from "../components/ui/AppSelect";

const RetailerWholesalerVendorMenu = () => {
  const user = getUserFromLocalStorage();
  const vendorId = user?.result?._id || "";
  const sections = useSelector(
    (state) => state.retailerWholesalerSections.sectionsRW
  );
  const retailersWholesalers = useSelector(
    (state) => state.retailerWholesalerSections.retailersWholesalers
  );
  //   console.log(retailersWholesalers, "retailersWholesalers>>>>>>");
  const optionGroups = useSelector(
    (state) => state.retailerWholesalerOptions.optionGroups
  );
  const options = useSelector(
    (state) => state.retailerWholesalerOptions.options
  );
  const loading = useSelector(
    (state) => state.retailerWholesalerSections.isLoading
  );
  const retailerWholesalerLoading = useSelector(
    (state) => state.retailerWholesalerSections.isLoading
  );
  const optionLoading = useSelector((state) => state.options.isLoading);
  const isLoadingDeleteOptionGroup = useSelector(
    (state) => state.options.isLoading
  );

  const [showCreateModal, setShowCreateModal] = useState(false);
  const [sectionsLoaded, setSectionsLoaded] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [sectionTitle, setSectionTitle] = useState("");
  const [sectionDescription, setSectionDescription] = useState("");
  const [selectedRetailerWholesalerId, setSelectedRetailerWholesalerId] =
    useState("");
  const [activeKey, setActiveKey] = useState([]);
  const [activeNav, setActiveNav] = useState("menu-overview");
  const [currentSectionId, setCurrentSectionId] = useState(null);

  const [showProductModal, setShowProductModal] = useState(false); // New state for product modal
  const [productName, setProductName] = useState(""); // New state for product name
  const [productDescription, setProductDescription] = useState(""); // New state for product description
  const [productPrice, setProductPrice] = useState(0); // New state for product price
  const [productImage, setProductImage] = useState(""); // New state for product image
  // const [currentProductId, setCurrentProductId] = useState(null); // New state for current product id

  const [showOptionModal, setShowOptionModal] = useState(false);
  const [optionName, setOptionName] = useState("");
  const [optionPrice, setOptionPrice] = useState(0);

  const [showOptionGroupModal, setShowOptionGroupModal] = useState(false);
  const [optionGroupName, setOptionGroupName] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [minOptions, setMinOptions] = useState(0);
  const [maxOptions, setMaxOptions] = useState(0);
  const [currentOptionGroupId, setCurrentOptionGroupId] = useState(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  // Vendor team permissions: sections, products and options are
  // catalogue:edit; switching a product on or off is catalogue:activate.
  const catalogueGate = useGate("catalogue:edit");
  const activateGate = useGate("catalogue:activate");
  const [sectionToDelete, setSectionToDelete] = useState(null);
  const [showOptionGroupDeleteModal, setShowOptionGroupDeleteModal] =
    useState(false);
  const [optionGroupToDelete, setOptionGroupToDelete] = useState(null);
  const [showOptionDeleteModal, setShowOptionDeleteModal] = useState(false);
  const [optionToDelete, setOptionToDelete] = useState(null);

  const [showEditOptionModal, setShowEditOptionModal] = useState(false);
  const [currentOptionId, setCurrentOptionId] = useState(null);
  const [editOptionName, setEditOptionName] = useState("");
  const [editOptionPrice, setEditOptionPrice] = useState(0);
  const [editOptionEnabled, setEditOptionEnabled] = useState(true);

  // Image hover preview
  const [hoveredImage, setHoveredImage] = useState(null);
  const [imagePreviewPosition, setImagePreviewPosition] = useState({ x: 0, y: 0 });

  const dispatch = useDispatch();
  const history = useHistory();

  const hasSections = Array.isArray(sections) && sections.length > 0;

  // A product cannot exist outside a section, so the first-time catalog screen
  // must make that dependency explicit instead of sending a new vendor into a
  // product form they cannot complete. Also preselect the vendor when there is
  // only one profile — the common self-service case — while preserving the
  // selector for staff who manage more than one vendor.
  const openCreateSectionModal = () => {
    if (!selectedRetailerWholesalerId && retailersWholesalers.length === 1) {
      setSelectedRetailerWholesalerId(retailersWholesalers[0].owner);
    }
    setShowCreateModal(true);
  };

  useEffect(() => {
    const vendorId = user?.result?._id || "";
    const isSuperAdmin = user?.result?.user_role === "SUPERUSER";
    let cancelled = false;

    setSectionsLoaded(false);
    dispatch(fetchRetailerWholesalers(vendorId));
    Promise.resolve(dispatch(fetchRetailerWholesalerSections(vendorId))).finally(() => {
      if (!cancelled) setSectionsLoaded(true);
    });
    dispatch(fetchRetailerWholesalerOptionGroups(vendorId));
    dispatch(fetchRetailerWholesalerOptions(vendorId));

    return () => {
      cancelled = true;
    };
  }, [dispatch, vendorId]);

  useEffect(() => {
    if (sections.length > 0) {
      setActiveKey(sections.map((section) => String(section._id)));
    }
  }, [sections]);

  const handleMenuSectionSubmit = (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!sectionTitle.trim()) {
      toast.error("Section title is required");
      return;
    }
    
    if (!sectionDescription.trim()) {
      toast.error("Section description is required");
      return;
    }
    
    if (!selectedRetailerWholesalerId) {
      toast.error("Please select a vendor");
      return;
    }
    
    dispatch(
      createRetailerWholesalerSection(
        {
          title: sectionTitle,
          description: sectionDescription,
          retailerWholesalerId: selectedRetailerWholesalerId,
        },
        vendorId
      )
    );
    setShowCreateModal(false);
    setSectionTitle("");
    setSectionDescription("");
    setSelectedRetailerWholesalerId("");
  };

  const handleSectionEditSubmit = (e) => {
    e.preventDefault();
    dispatch(
      updateRetailerWholesalerSection(currentSectionId, {
        title: sectionTitle,
        description: sectionDescription,
        retailerWholesalerId: selectedRetailerWholesalerId,
      })
    );
    setShowEditModal(false);
    setSectionTitle("");
    setSectionDescription("");
    setSelectedRetailerWholesalerId("");
  };

  const handleAddRetailerWholesalerProductClick = () => {
    if (!hasSections) {
      toast.info("Create your first section before adding a product.");
      openCreateSectionModal();
      return;
    }
    history.push("/admin/rw-product-create");
  };

  const handleProductSubmit = (e) => {
    e.preventDefault();
    const productData = {
      name: productName,
      description: productDescription,
      price: productPrice,
      image: productImage,
      retailerWholesalerId: selectedRetailerWholesalerId,
      sectionId: currentSectionId,
    };

    dispatch(createRetailerWholesalerProduct(productData));
    setShowProductModal(false);
    setProductName("");
    setProductDescription("");
    setProductPrice(0);
    setProductImage("");
  };

  const handleSectionClick = (eventKey) => {
    setActiveKey((prevActiveKey) =>
      prevActiveKey.includes(eventKey)
        ? prevActiveKey.filter((key) => key !== eventKey)
        : [...prevActiveKey, eventKey]
    );
  };

  // Quick per-item activate/deactivate — unified endpoint, realtime sockets:
  // storefronts (web /shop, vendor pages, mobile apps) drop/restore the item
  // live via the catalog:public `product:statusChanged` event.
  const handleToggleProductStatus = async (e, product) => {
    e.stopPropagation();
    const next = !product.enabled;
    try {
      await apiSetCatalogItemStatus("retail", product._id, next);
      toast.success(`"${product.name}" ${next ? "activated" : "deactivated"}`);
      dispatch(fetchRetailerWholesalerSections(vendorId));
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "Failed to change product status"
      );
    }
  };

  const handleEditProduct = (productId) => {
    const productToEdit = sections
      .flatMap((section) => section.products)
      .find((product) => product._id === productId);

    if (productToEdit) {
      history.push({
        pathname: `/admin/edit-catalog-product/${productId}`,
        state: { productDetails: productToEdit },
      });
    } else {
      console.error("Product not found!");
    }
  };

  const handleAddProductToSection = (sectionId) => {
    history.push({
      pathname: "/admin/rw-product-create",
      state: { sectionId },
    });
  };

  const handleEditSection = (
    sectionId,
    sectionTitle,
    sectionDescription,
    retailerWholesalerId
  ) => {
    setCurrentSectionId(sectionId);
    setSectionTitle(sectionTitle);
    setSectionDescription(sectionDescription);
    setSelectedRetailerWholesalerId(retailerWholesalerId);
    setShowEditModal(true);
  };

  const handleOptionSubmit = (e) => {
    e.preventDefault();
    dispatch(
      createRetailerWholesalerOption({
        name: optionName,
        price: optionPrice,
        owner: vendorId,
      })
    );
    setShowOptionModal(false);
    setOptionName("");
    setOptionPrice(0);
  };

  const handleOptionGroupSubmit = async (e) => {
    e.preventDefault();

    if (!selectedRetailerWholesalerId) {
      toast.warn("Please select a retailer or wholesaler");
      return;
    }

    const optionGroupData = {
      name: optionGroupName,
      retailerWholesalerProductId: selectedRetailerWholesalerId,
      options: selectedOptions.map((option) => ({
        value: option.value,
        mandatory: minOptions > 0, // Set mandatory based on minOptions
      })),
      minOptions,
      maxOptions,
      owner: vendorId,
    };

    if (currentOptionGroupId) {
      await dispatch(
        updateRetailerWholesalerOptionGroup(
          currentOptionGroupId,
          optionGroupData
        )
      );
    } else {
      await dispatch(createRetailerWholesalerOptionGroup(optionGroupData));
    }

    dispatch(fetchRetailerWholesalerOptionGroups(vendorId));

    setShowOptionGroupModal(false);
    setOptionGroupName("");
    setSelectedRetailerWholesalerId("");
    setSelectedOptions([]);
    setMinOptions(0);
    setMaxOptions(0);
    setCurrentOptionGroupId(null);
  };

  const handleEditOptionGroup = (optionGroup) => {
    setCurrentOptionGroupId(optionGroup._id);
    setOptionGroupName(optionGroup.name);
    setSelectedRetailerWholesalerId(optionGroup.retailerWholesalerProductId);
    setSelectedOptions(
      optionGroup.options
        .map((option) => {
          if (option.option && option.option._id) {
            return {
              value: option.option._id,
              label: `${option.option.name} - ${new Intl.NumberFormat("en-UG", {
                style: "currency",
                currency: "UGX",
              }).format(option.option.price)}`,
              mandatory: option.mandatory,
            };
          }
          return null;
        })
        .filter((option) => option !== null)
    );
    setMinOptions(optionGroup.minOptions);
    setMaxOptions(optionGroup.maxOptions);
    setShowOptionGroupModal(true);
  };

  const handleDeleteOption = (optionId) => {
    setOptionToDelete(optionId);
    setShowOptionDeleteModal(true);
  };

  const confirmDeleteOption = async () => {
    try {
      await dispatch(deleteRetailerWholesalerOption(optionToDelete));
      setShowOptionDeleteModal(false);
      setOptionToDelete(null);
    } catch (error) {
      toast.error("Failed to delete the option. Please try again.");
    }
  };

  const handleDeleteSection = (sectionId) => {
    setSectionToDelete(sectionId);
    setShowDeleteModal(true);
  };

  const confirmDeleteSection = async () => {
    try {
      await dispatch(
        deleteRetailerWholesalerSection(vendorId, sectionToDelete)
      );
      // toast.success('Section and its products deleted successfully');
      setShowDeleteModal(false);
      setSectionToDelete(null);
    } catch (error) {
      toast.error("Failed to delete the section. Please try again.");
    }
  };

  const handleDeleteOptionGroup = (optionGroupId) => {
    setOptionGroupToDelete(optionGroupId);
    setShowOptionGroupDeleteModal(true);
  };

  const confirmDeleteOptionGroup = async () => {
    try {
      await dispatch(deleteRetailerWholesalerOptionGroup(optionGroupToDelete));
      setShowOptionGroupDeleteModal(false);
      setOptionGroupToDelete(null);
    } catch (error) {
      toast.error("Failed to delete the option group. Please try again.");
    }
  };

  const handleEditOption = (option) => {
    setCurrentOptionId(option._id);
    setEditOptionName(option.name);
    setEditOptionPrice(option.price);
    setEditOptionEnabled(option.enabled);
    setShowEditOptionModal(true);
  };

  const handleEditOptionSubmit = (e) => {
    e.preventDefault();
    const updatedOption = {
      name: editOptionName,
      price: editOptionPrice,
      enabled: editOptionEnabled,
    };
    dispatch(updateRetailerWholesalerOption(currentOptionId, updatedOption));
    setShowEditOptionModal(false);
    setEditOptionName("");
    setEditOptionPrice(0);
    setCurrentOptionId(null);
  };

  return (
    <Col md="10">
      <Card>
        <Card.Header className="d-flex justify-content-between align-items-center">
          <div style={{ paddingBottom: "15px" }}>
            <Card.Title as="h3" style={{ paddingBottom: "5px" }}>
              Sections
            </Card.Title>
            <p className="card-category">
              {user?.result?.operationMode} | {user?.result?.businessName} ~
              Sections Management Portal.
            </p>
          </div>
          {!sectionsLoaded ? (
            <Spinner animation="border" size="sm" role="status" style={{ marginRight: "40px" }}>
              <span className="sr-only">Loading catalog...</span>
            </Spinner>
          ) : !catalogueGate.allowed ? null : !hasSections ? (
            <Button
              variant="primary"
              onClick={openCreateSectionModal}
              style={{
                marginRight: "40px",
                padding: "10px 18px",
                fontSize: "14px",
                fontWeight: 700,
              }}
            >
              Create first section
            </Button>
          ) : (
            <DropdownButton
              id="dropdown-item-button"
              title="Add"
              variant="primary"
              style={{
                marginRight: "40px",
                padding: "8px 16px",
                fontSize: "14px",
                cursor: "pointer",
              }}
            >
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip id="tooltip-add-section">
                  Create a category to group related products — e.g. "Electronics" or "Clothing". Sections help customers browse your catalog.
                </Tooltip>
              }
            >
              <Dropdown.Item
                as="button"
                type="button"
                onClick={openCreateSectionModal}
              >
                Add section
              </Dropdown.Item>
            </OverlayTrigger>
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip id="tooltip-add-product">
                  Add a new individual listing to your catalog — name, price, image, and the section it belongs to.
                </Tooltip>
              }
            >
              <Dropdown.Item
                as="button"
                type="button"
                onClick={handleAddRetailerWholesalerProductClick}
              >
                Add product
              </Dropdown.Item>
            </OverlayTrigger>
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip id="tooltip-add-collection">
                  Group products into a curated collection — e.g. "New Arrivals" or "Best Sellers" — for featured display on your shop page.
                </Tooltip>
              }
            >
              <Dropdown.Item
                as="button"
                type="button"
                onClick={() => {
                  /* handle add collection */
                }}
              >
                Add collection
              </Dropdown.Item>
            </OverlayTrigger>
            </DropdownButton>
          )}
        </Card.Header>
        <Nav
          variant="tabs"
          activeKey={activeNav}
          onSelect={(selectedKey) => setActiveNav(selectedKey)}
          style={{
            position: "sticky",
            top: 0,
            zIndex: 1000,
            backgroundColor: "white",
          }}
        >
          <Nav.Item>
            <Nav.Link
              eventKey="menu-overview"
              style={{
                backgroundColor:
                  activeNav === "menu-overview" ? "#FF6B1A" : "black",
                color: activeNav === "menu-overview" ? "white" : "white",
                cursor: "pointer",
              }}
            >
              Section Overview
            </Nav.Link>
          </Nav.Item>
          <Nav.Item style={{ margin: "0 1px" }}>
            <Nav.Link
              eventKey="products"
              style={{
                backgroundColor: activeNav === "products" ? "#FF6B1A" : "black",
                color: activeNav === "products" ? "white" : "white",
                cursor: "pointer",
              }}
            >
              Products
            </Nav.Link>
          </Nav.Item>
          <Nav.Item style={{ margin: "0 1px" }}>
            <Nav.Link
              eventKey="option-groups"
              style={{
                backgroundColor:
                  activeNav === "option-groups" ? "#FF6B1A" : "black",
                color: activeNav === "option-groups" ? "white" : "white",
                cursor: "pointer",
              }}
            >
              Option Groups
            </Nav.Link>
          </Nav.Item>
          <Nav.Item style={{ margin: "0 1px" }}>
            <Nav.Link
              eventKey="options"
              style={{
                backgroundColor: activeNav === "options" ? "#FF6B1A" : "black",
                color: activeNav === "options" ? "white" : "white",
                cursor: "pointer",
              }}
            >
              Options
            </Nav.Link>
          </Nav.Item>
          <Nav.Item style={{ margin: "0 1px" }}>
            <Nav.Link
              eventKey="simulation"
              style={{
                backgroundColor:
                  activeNav === "simulation" ? "#FF6B1A" : "black",
                color: activeNav === "simulation" ? "white" : "white",
                cursor: "pointer",
              }}
            >
              Simulation
            </Nav.Link>
          </Nav.Item>
          <Nav.Item style={{ margin: "0 1px" }}>
            <Nav.Link
              eventKey="how-it-works"
              style={{
                backgroundColor:
                  activeNav === "how-it-works" ? "#FF6B1A" : "black",
                color: activeNav === "how-it-works" ? "white" : "white",
                cursor: "pointer",
              }}
            >
              <MdHelpOutline size={16} style={{ marginRight: "6px", verticalAlign: "middle" }} />
              How it works
            </Nav.Link>
          </Nav.Item>
        </Nav>

        <Card.Body>
          {!sectionsLoaded || loading || retailerWholesalerLoading || optionLoading ? (
            <div className="d-flex justify-content-center">
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            </div>
          ) : (
            <>
              {activeNav === "menu-overview" && (
                <>
                  {!hasSections ? (
                    <div
                      style={{
                        maxWidth: "760px",
                        margin: "22px auto 30px",
                        padding: "36px 32px",
                        border: "1px solid #cfe2ff",
                        borderRadius: "16px",
                        background: "linear-gradient(135deg, #f7fbff 0%, #ffffff 70%)",
                        textAlign: "center",
                        boxShadow: "0 8px 24px rgba(21, 101, 192, 0.08)",
                      }}
                    >
                      <div
                        style={{
                          display: "inline-block",
                          marginBottom: "12px",
                          padding: "5px 12px",
                          borderRadius: "999px",
                          backgroundColor: "#e3f2fd",
                          color: "#1565c0",
                          fontSize: "12px",
                          fontWeight: 800,
                          letterSpacing: "0.05em",
                          textTransform: "uppercase",
                        }}
                      >
                        New catalog setup
                      </div>
                      <h4 style={{ marginBottom: "10px", fontWeight: 800, color: "#172033" }}>
                        Create a section before adding products
                      </h4>
                      <p
                        style={{
                          maxWidth: "590px",
                          margin: "0 auto 24px",
                          color: "#5f6b7a",
                          fontSize: "15px",
                          lineHeight: 1.6,
                        }}
                      >
                        Sections are the categories customers use to browse your shop,
                        such as Electronics, Bedding, Drinks, or Building Materials.
                        Every product must belong to one.
                      </p>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "stretch",
                          gap: "12px",
                          flexWrap: "wrap",
                          marginBottom: "26px",
                        }}
                      >
                        {[
                          ["1", "Create a section", "Name the first category in your shop."],
                          ["2", "Add products", "Add listings inside that section."],
                        ].map(([step, title, description]) => (
                          <div
                            key={step}
                            style={{
                              flex: "1 1 240px",
                              maxWidth: "300px",
                              display: "flex",
                              alignItems: "flex-start",
                              gap: "12px",
                              padding: "16px",
                              border: "1px solid #e3e8ef",
                              borderRadius: "12px",
                              backgroundColor: "#ffffff",
                              textAlign: "left",
                            }}
                          >
                            <div
                              style={{
                                width: "30px",
                                height: "30px",
                                flexShrink: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "50%",
                                backgroundColor: step === "1" ? "#1565c0" : "#eef2f6",
                                color: step === "1" ? "#ffffff" : "#52606d",
                                fontWeight: 800,
                              }}
                            >
                              {step}
                            </div>
                            <div>
                              <div style={{ fontWeight: 800, color: "#172033", marginBottom: "3px" }}>
                                {title}
                              </div>
                              <div style={{ color: "#6c757d", fontSize: "13px", lineHeight: 1.45 }}>
                                {description}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          gap: "10px",
                          flexWrap: "wrap",
                        }}
                      >
                        <Gated perm="catalogue:edit">
                        <Button variant="primary" onClick={openCreateSectionModal} style={{ fontWeight: 700 }}>
                          Create my first section
                        </Button>
                        </Gated>
                        <Button
                          variant="outline-secondary"
                          onClick={() => setActiveNav("how-it-works")}
                        >
                          View setup guide
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <>
                  {/* ── Summary stat strip ── */}
                  {(() => {
                    const allProducts = sections.flatMap((s) => s.products || []);
                    const totalSections = sections.length;
                    const totalProducts = allProducts.length;
                    const activeProducts = allProducts.filter((p) => p.enabled).length;
                    const inactiveProducts = totalProducts - activeProducts;

                    const chips = [
                      { label: "Sections",          value: totalSections,   bg: "#e3f2fd", color: "#1565c0", border: "#90caf9" },
                      { label: "Total Listings",     value: totalProducts,   bg: "#f3e5f5", color: "#6a1b9a", border: "#ce93d8" },
                      { label: "Active Listings",    value: activeProducts,  bg: "#e8f5e9", color: "#2e7d32", border: "#a5d6a7" },
                      { label: "Inactive Listings",  value: inactiveProducts, bg: "#fff3e0", color: "#e65100", border: "#ffcc80" },
                    ];

                    return (
                      <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: "18px" }}>
                        {chips.map(({ label, value, bg, color, border }) => (
                          <div
                            key={label}
                            style={{
                              background: bg,
                              border: `1.5px solid ${border}`,
                              borderRadius: "10px",
                              padding: "10px 18px",
                              minWidth: "110px",
                              textAlign: "center",
                            }}
                          >
                            <div style={{ fontSize: "1.4rem", fontWeight: 800, color, lineHeight: 1.1 }}>{value}</div>
                            <div style={{ fontSize: "0.72rem", fontWeight: 700, color, textTransform: "uppercase", letterSpacing: "0.06em", marginTop: "3px" }}>{label}</div>
                          </div>
                        ))}
                      </div>
                    );
                  })()}

                <Accordion
                  defaultActiveKey={activeKey}
                  activeKey={activeKey}
                  onSelect={handleSectionClick}
                >
                  {sections.map((section) => (
                    <Accordion.Item
                      eventKey={String(section._id)}
                      key={section._id}
                    >
                      <Accordion.Header
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <span
                          style={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <span style={{ marginRight: "auto" }}>
                            {section.title} | {section.productCount ?? section.products?.length ?? 0} products
                          </span>
                          {catalogueGate.allowed && (
                          <>
                          <div
                            style={{
                              width: "30px",
                              padding: "0",
                              margin: "0 10px",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              handleEditSection(
                                section._id,
                                section.title,
                                section.description,
                                section.products?.[0]?.retailerWholesalerId ||
                                  section.retailerWholesalerId
                              )
                            }
                          >
                            <MdEdit size="24px" />
                          </div>
                          <div
                            style={{
                              width: "30px",
                              padding: "0",
                              margin: "0 10px",
                              cursor: "pointer",
                            }}
                            onClick={() => handleDeleteSection(section._id)}
                          >
                            <MdDelete size="24px" color="#f44336" />
                          </div>
                          </>
                          )}
                        </span>
                        {catalogueGate.allowed && (
                        <div
                          style={{
                            marginRight: "12px",
                            padding: "6px 12px",
                            backgroundColor: "#010221",
                            color: "white",
                            borderRadius: "4px",
                            cursor: "pointer",
                            display: "inline-block",
                            textAlign: "center",
                          }}
                          onClick={() => handleAddProductToSection(section._id)}
                        >
                          +Add product
                        </div>
                        )}
                      </Accordion.Header>
                      <Accordion.Body>
                        {section.products &&
                          section.products.map((product) => (
                            <div
                              key={product._id}
                              className="d-flex align-items-center justify-content-between"
                              style={{
                                marginBottom: "10px",
                                borderBottom: "1px solid #ccc",
                                paddingBottom: "10px",
                                cursor: "pointer",
                              }}
                              onClick={() => handleEditProduct(product._id)}
                            >
                              <div className="d-flex align-items-center">
                                <div
                                  style={{ position: "relative", marginRight: "10px", flexShrink: 0 }}
                                  onMouseEnter={(e) => {
                                    const rect = e.currentTarget.getBoundingClientRect();
                                    setHoveredImage(product.image || placeholderImage);
                                    setImagePreviewPosition({ x: rect.left + rect.width + 16, y: rect.top });
                                  }}
                                  onMouseLeave={() => setHoveredImage(null)}
                                >
                                  <img
                                    src={product.image || placeholderImage}
                                    alt={product.name}
                                    style={{
                                      width: "50px",
                                      height: "50px",
                                      borderRadius: "20%",
                                      display: "block",
                                      cursor: "zoom-in",
                                    }}
                                  />
                                </div>
                                <div>
                                  <h6>{product.name}</h6>
                                  <p
                                    style={{
                                      marginBottom: 0,
                                      fontSize: "12px",
                                    }}
                                  >
                                    {product.description || "Add description"}
                                  </p>
                                  {!product.enabled && (
                                    <p
                                      style={{
                                        marginBottom: 0,
                                        fontSize: "12px",
                                        color: "red",
                                      }}
                                    >
                                      (Deactivated)
                                    </p>
                                  )}
                                </div>
                              </div>
                              <div className="d-flex align-items-center">
                                <div
                                  style={{
                                    fontSize: "14px",
                                    fontFamily: "monospace",
                                    fontWeight: "lighter",
                                  }}
                                >
                                  {new Intl.NumberFormat("en-UG", {
                                    style: "currency",
                                    currency: "UGX",
                                  }).format(product.price)}
                                </div>
                                <span
                                  onClick={(e) => e.stopPropagation()}
                                  title={
                                    !activateGate.allowed
                                      ? GATE_TITLE
                                      : product.enabled
                                        ? "Deactivate this item (hides it from shoppers instantly)"
                                        : "Activate this item (shoppers see it instantly)"
                                  }
                                >
                                  <Switch
                                    size="small"
                                    checked={!!product.enabled}
                                    disabled={!activateGate.allowed}
                                    onChange={(e) =>
                                      handleToggleProductStatus(e, product)
                                    }
                                    color="primary"
                                  />
                                </span>
                              </div>
                            </div>
                          ))}
                        {(!section.products ||
                          section.products.length === 0) && (
                          <div
                            style={{
                              padding: "26px 18px",
                              border: "1px dashed #90caf9",
                              borderRadius: "10px",
                              backgroundColor: "#f7fbff",
                              textAlign: "center",
                            }}
                          >
                            <div style={{ fontWeight: 800, color: "#172033", marginBottom: "6px" }}>
                              Your section is ready
                            </div>
                            <p style={{ margin: "0 auto 14px", color: "#6c757d", fontSize: "13px" }}>
                              Now add the first product to <strong>{section.title}</strong>.
                            </p>
                            <Button
                              variant="primary"
                              size="sm"
                              onClick={() => handleAddProductToSection(section._id)}
                              {...catalogueGate.disabledProps}
                              style={{ fontWeight: 700 }}
                            >
                              Add first product
                            </Button>
                          </div>
                        )}
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
                    </>
                  )}
                </>
              )}
              {activeNav === "products" && (
                <div>
                  {sections.map(
                    (section) =>
                      section.products &&
                      section.products.map(
                        (product) =>
                          product.enabled && (
                            <Card
                              key={product._id}
                              className="mb-3 shadow-sm border-2"
                            >
                              <Card.Body>
                                <div className="d-flex justify-content-between">
                                  <div>
                                    <Card.Title>{product.name}</Card.Title>
                                    <Card.Text
                                      as="p"
                                      style={{ fontSize: "13px" }}
                                    >
                                      {product.description}
                                    </Card.Text>
                                  </div>
                                  <div
                                    onMouseEnter={(e) => {
                                      const rect = e.currentTarget.getBoundingClientRect();
                                      setHoveredImage(product.image || placeholderImage);
                                      setImagePreviewPosition({ x: rect.left + rect.width + 16, y: rect.top });
                                    }}
                                    onMouseLeave={() => setHoveredImage(null)}
                                    style={{ cursor: "zoom-in" }}
                                  >
                                    <img
                                      src={product.image || placeholderImage}
                                      alt={product.name}
                                      style={{
                                        width: "60px",
                                        height: "60px",
                                        borderRadius: "20%",
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="d-flex justify-content-between mt-2">
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      fontFamily: "monospace",
                                      fontWeight: "lighter",
                                      color: "green",
                                    }}
                                  >
                                    {new Intl.NumberFormat("en-UG", {
                                      style: "currency",
                                      currency: "UGX",
                                    }).format(product.price)}
                                  </div>
                                  <Button
                                    variant="danger"
                                    size="md"
                                    onClick={() =>
                                      handleEditProduct(product._id)
                                    }
                                  >
                                    Edit
                                  </Button>
                                </div>
                              </Card.Body>
                            </Card>
                          )
                      )
                  )}
                </div>
              )}
              {activeNav === "option-groups" && (
                <div>
                  <Button
                    variant="primary"
                    onClick={() => setShowOptionGroupModal(true)}
                    {...catalogueGate.disabledProps}
                  >
                    Add Option Group
                  </Button>
                  <ListGroup className="mt-4">
                    {optionGroups.map((optionGroup) => (
                      <ListGroup.Item
                        key={optionGroup._id}
                        className="d-flex justify-content-between align-items-center"
                        onClick={() => handleEditOptionGroup(optionGroup)}
                        style={{ cursor: "pointer" }}
                      >
                        <div>
                          <h5>{optionGroup.name}</h5>
                          <p className="mb-0">
                            Min: {optionGroup.minOptions} | Max:{" "}
                            {optionGroup.maxOptions}
                          </p>
                        </div>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-delete-${optionGroup._id}`}>
                              Delete Option Group
                            </Tooltip>
                          }
                        >
                          <Button
                            variant="danger"
                            size="sm"
                            {...catalogueGate.disabledProps}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDeleteOptionGroup(optionGroup._id);
                            }}
                          >
                            <MdDelete />
                          </Button>
                        </OverlayTrigger>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </div>
              )}
              {activeNav === "options" && (
                <div>
                  <Button
                    variant="primary"
                    onClick={() => setShowOptionModal(true)}
                    {...catalogueGate.disabledProps}
                  >
                    Add Option
                  </Button>
                  <ListGroup className="mt-4">
                    {options.map((option) => (
                      <ListGroup.Item
                        key={option._id}
                        className="d-flex justify-content-between align-items-center"
                      >
                        <div>
                          <strong
                            style={{
                              fontSize: "14px",
                              fontFamily: "monospace",
                              fontWeight: "lighter",
                            }}
                          >
                            {option.name}
                          </strong>{" "}
                          -
                          <span
                            style={{
                              fontSize: "14px",
                              fontFamily: "monospace",
                              fontWeight: "lighter",
                              color: "green",
                              paddingLeft: "5px",
                            }}
                          >
                            {new Intl.NumberFormat("en-UG", {
                              style: "currency",
                              currency: "UGX",
                            }).format(option.price)}
                          </span>
                        </div>
                        <div>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id={`tooltip-edit-${option._id}`}>
                                Edit Option
                              </Tooltip>
                            }
                          >
                            <Button
                              variant="primary"
                              size="sm"
                              {...catalogueGate.disabledProps}
                              onClick={() => handleEditOption(option)}
                              style={{ marginRight: "5px" }} // Adding space between buttons
                            >
                              <MdEdit />
                            </Button>
                          </OverlayTrigger>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id={`tooltip-delete-${option._id}`}>
                                Delete Option
                              </Tooltip>
                            }
                          >
                            <Button
                              variant="danger"
                              size="sm"
                              {...catalogueGate.disabledProps}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteOption(option._id);
                              }}
                            >
                              <MdDelete />
                            </Button>
                          </OverlayTrigger>
                        </div>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </div>
              )}
              {activeNav === "simulation" && (
                <ProductSimulation
                  sections={sections}
                  variant="rw"
                  storeName={user?.result?.businessName || ""}
                />
              )}
              {activeNav === "how-it-works" && (
                <div style={{ padding: "20px" }}>
                  <div style={{ marginBottom: "30px" }}>
                    <h4 style={{ color: "#FF6B1A", marginBottom: "10px", fontWeight: "700" }}>
                      Welcome to Catalog Management
                    </h4>
                    <p style={{ color: "#6c757d", fontSize: "14px" }}>
                      This guide will help you set up and manage your product catalog effectively for retail and wholesale operations.
                    </p>
                  </div>
                  <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <strong>1. Getting Started</strong>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>The Catalog Management system helps you organize and manage your retail or wholesale inventory efficiently.</p>
                        <ul>
                          <li><strong>Sections:</strong> Categories that group related products (e.g., "Electronics", "Clothing", "Home & Garden")</li>
                          <li><strong>Products:</strong> Individual catalog items available for purchase</li>
                          <li><strong>Options & Option Groups:</strong> Product variations like colors, sizes, and configurations</li>
                        </ul>
                        <p style={{ marginTop: "10px", padding: "10px", backgroundColor: "#fff3e0", borderLeft: "4px solid #FF6B1A", fontSize: "13px" }}>
                          <strong>Tip:</strong> Start by creating product sections first, then add catalog items to those sections for better organization.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="1">
                      <Accordion.Header>
                        <strong>2. Creating Sections</strong>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>Sections organize your catalog into logical product categories.</p>
                        <ol>
                          <li>Click the <strong>"Add"</strong> dropdown and select <strong>"Add section"</strong></li>
                          <li>Enter a descriptive section title (e.g., "Consumer Electronics", "Office Supplies", "Building Materials")</li>
                          <li>Add a section description to explain the category (required)</li>
                          <li>Select your vendor profile from the dropdown (required)</li>
                          <li>Click <strong>"Create Section"</strong> to save</li>
                        </ol>
                        <p style={{ marginTop: "10px", fontSize: "13px", color: "#666" }}>
                          Both title and description are required fields. You can edit or delete sections using the icons in the section header.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="2">
                      <Accordion.Header>
                        <strong>3. Adding Products</strong>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>Once you have sections created, you can add catalog items to your inventory.</p>
                        <ol>
                          <li>Click <strong>"+Add product"</strong> within a section, or use the main <strong>"Add"</strong> dropdown</li>
                          <li>Fill in the product details:
                            <ul style={{ marginTop: "8px" }}>
                              <li><strong>Name:</strong> Product name as it appears to customers (required)</li>
                              <li><strong>Description:</strong> Detailed product information, features, and specifications</li>
                              <li><strong>Price:</strong> Retail or wholesale price in UGX</li>
                              <li><strong>Image:</strong> Product photo or catalog image (URL or upload)</li>
                              <li><strong>Section:</strong> Which category this product belongs to</li>
                            </ul>
                          </li>
                          <li>Set stock quantities and availability</li>
                          <li>Enable/disable the product for customer visibility</li>
                          <li>Save the product</li>
                        </ol>
                        <p style={{ marginTop: "10px", padding: "10px", backgroundColor: "#e3f2fd", borderLeft: "4px solid #2196f3", fontSize: "13px" }}>
                          <strong>Note:</strong> Click on any product to edit its details, update pricing, or modify stock levels.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="3">
                      <Accordion.Header>
                        <strong>4. Product Information Best Practices</strong>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>High-quality product information increases customer confidence and sales.</p>
                        
                        <h6 style={{ color: "#FF6B1A", marginTop: "10px" }}>Images</h6>
                        <ul>
                          <li>Use clear, high-resolution product photos</li>
                          <li>Maintain consistent image dimensions across your catalog</li>
                          <li>Show products from multiple angles when possible</li>
                          <li>Use white or neutral backgrounds for a professional look</li>
                        </ul>
                        
                        <h6 style={{ color: "#FF6B1A", marginTop: "15px" }}>Descriptions</h6>
                        <ul>
                          <li>Include key features, specifications, and dimensions</li>
                          <li>Mention materials, compatibility, or usage instructions</li>
                          <li>Keep descriptions clear and concise</li>
                          <li>Use consistent formatting across all products</li>
                        </ul>
                        
                        <h6 style={{ color: "#FF6B1A", marginTop: "15px" }}>Pricing</h6>
                        <ul>
                          <li>Set competitive prices based on market research</li>
                          <li>Update prices regularly to reflect market changes</li>
                          <li>Consider bulk pricing for wholesale operations</li>
                          <li>Ensure prices are clearly displayed in UGX</li>
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="4">
                      <Accordion.Header>
                        <strong>5. Options & Option Groups</strong>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>Options allow customers to select product variations and configurations.</p>
                        
                        <h6 style={{ color: "#FF6B1A", marginTop: "10px" }}>Creating Options</h6>
                        <ol>
                          <li>Go to the <strong>"Options"</strong> tab</li>
                          <li>Click <strong>"Add Option"</strong></li>
                          <li>Enter the option name (e.g., "Red", "Size XL", "2TB Storage")</li>
                          <li>Set any additional price for this option</li>
                          <li>Save the option</li>
                        </ol>
                        
                        <h6 style={{ color: "#FF6B1A", marginTop: "15px" }}>Creating Option Groups</h6>
                        <ol>
                          <li>Go to the <strong>"Option Groups"</strong> tab</li>
                          <li>Click <strong>"Add Option Group"</strong></li>
                          <li>Name the group (e.g., "Color", "Size", "Storage Capacity")</li>
                          <li>Select your vendor profile</li>
                          <li>Choose which options belong to this group</li>
                          <li>Set minimum and maximum selections:
                            <ul style={{ marginTop: "5px" }}>
                              <li><strong>Min = 1, Max = 1:</strong> Customer must choose exactly one (e.g., color)</li>
                              <li><strong>Min = 0, Max = 3:</strong> Customer can choose up to 3 optional features</li>
                            </ul>
                          </li>
                          <li>Save the option group</li>
                        </ol>
                        
                        <p style={{ marginTop: "10px", fontSize: "13px", color: "#666" }}>
                          You can edit options and option groups by clicking on them in their respective lists.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="5">
                      <Accordion.Header>
                        <strong>6. Using the Simulation Tab</strong>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>The Simulation tab shows a live preview of how your catalog will appear to customers on the web.</p>
                        
                        <h6 style={{ color: "#FF6B1A" }}>How to Use:</h6>
                        <ol>
                          <li>Click on the <strong>"Simulation"</strong> tab</li>
                          <li>View your sections and products as customers will see them</li>
                          <li>Check the following:
                            <ul style={{ marginTop: "8px" }}>
                              <li>Product images are clear and properly sized</li>
                              <li>Descriptions are informative and professional</li>
                              <li>Prices display correctly in UGX format</li>
                              <li>Product layout looks organized and appealing</li>
                              <li>Only enabled products are shown</li>
                            </ul>
                          </li>
                          <li>Make adjustments in the <strong>"Section Overview"</strong> or <strong>"Products"</strong> tabs as needed</li>
                        </ol>
                        
                        <p style={{ marginTop: "15px", padding: "10px", backgroundColor: "#e8f5e9", borderLeft: "4px solid #4caf50", fontSize: "13px" }}>
                          <strong>Best Practice:</strong> Use consistent image sizes, maintain similar description lengths, and keep pricing competitive. The simulation provides valuable insight into the customer experience!
                        </p>
                        
                        <p style={{ marginTop: "10px", fontSize: "13px", color: "#666" }}>
                          The simulation preview updates in real-time as you make changes to your catalog.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              )}
            </>
          )}
        </Card.Body>
      </Card>

      {/* Modal for creating a new section */}
      <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Create a new section</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="sectionTitle">
              <Form.Label>Section title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter section title..."
                value={sectionTitle}
                onChange={(e) => setSectionTitle(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="sectionDescription">
              <Form.Label>Section description</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter section description..."
                value={sectionDescription}
                onChange={(e) => setSectionDescription(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="retailerWholesalerSelect">
              <Form.Label>Select Vendor</Form.Label>
              <AppSelect block
                value={selectedRetailerWholesalerId}
                onChange={(e) =>
                  setSelectedRetailerWholesalerId(e.target.value)
                }
              >
                <option value="" disabled>
                  Select a retailer/wholesaler
                </option>
                {retailersWholesalers.map((retailerWholesaler) => (
                  <option
                    key={retailerWholesaler._id}
                    value={retailerWholesaler.owner}
                  >
                    {retailerWholesaler.name}
                  </option>
                ))}
              </AppSelect>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCreateModal(false)}>
            Cancel
          </Button>
          <Button 
            variant="success" 
            onClick={handleMenuSectionSubmit}
            disabled={!sectionTitle.trim() || !sectionDescription.trim() || !selectedRetailerWholesalerId}
            style={{
              opacity: (!sectionTitle.trim() || !sectionDescription.trim() || !selectedRetailerWholesalerId) ? 0.6 : 1,
              cursor: (!sectionTitle.trim() || !sectionDescription.trim() || !selectedRetailerWholesalerId) ? 'not-allowed' : 'pointer',
              backgroundColor: (!sectionTitle.trim() || !sectionDescription.trim() || !selectedRetailerWholesalerId) ? '#6c757d' : '',
              borderColor: (!sectionTitle.trim() || !sectionDescription.trim() || !selectedRetailerWholesalerId) ? '#6c757d' : '',
              color: '#ffffff'
            }}
          >
            Create Section
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for editing a section */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit section</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="sectionTitleEdit">
              <Form.Label>Section title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter section title..."
                value={sectionTitle}
                onChange={(e) => setSectionTitle(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="sectionDescriptionEdit">
              <Form.Label>Section description</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter section description..."
                value={sectionDescription}
                onChange={(e) => setSectionDescription(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="retailerWholesalerSelectEdit">
              <Form.Label>Select Vendor</Form.Label>
              <AppSelect block
                value={selectedRetailerWholesalerId}
                onChange={(e) =>
                  setSelectedRetailerWholesalerId(e.target.value)
                }
              >
                <option value="" disabled>
                  Select a Retailer or Wholesaler
                </option>
                {retailersWholesalers.map((retailerWholesaler) => (
                  <option
                    key={retailerWholesaler._id}
                    value={retailerWholesaler._id}
                  >
                    {retailerWholesaler.name}
                  </option>
                ))}
              </AppSelect>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleSectionEditSubmit}>
            Save changes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for creating a new product */}
      <Modal show={showProductModal} onHide={() => setShowProductModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Create a new product</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="productName">
              <Form.Label>Product name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter product name..."
                value={productName}
                onChange={(e) => setProductName(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="productDescription">
              <Form.Label>Product description</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter product description..."
                value={productDescription}
                onChange={(e) => setProductDescription(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="productPrice">
              <Form.Label>Product price</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter product price..."
                value={productPrice}
                onChange={(e) => setProductPrice(parseFloat(e.target.value))}
              />
            </Form.Group>
            <Form.Group controlId="productImage">
              <Form.Label>Product image</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter product image URL..."
                value={productImage}
                onChange={(e) => setProductImage(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowProductModal(false)}
          >
            Cancel
          </Button>
          <Button variant="success" onClick={handleProductSubmit}>
            Create product
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for creating a new option */}
      <Modal show={showOptionModal} onHide={() => setShowOptionModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Create a new option</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="optionName">
              <Form.Label>Option name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter option name..."
                value={optionName}
                onChange={(e) => setOptionName(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="optionPrice">
              <Form.Label>Option price</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter option price..."
                value={optionPrice}
                onChange={(e) => setOptionPrice(parseFloat(e.target.value))}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowOptionModal(false)}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleOptionSubmit}>
            Create option
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for creating or editing an option group */}
      <Modal
        show={showOptionGroupModal}
        onHide={() => setShowOptionGroupModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {currentOptionGroupId
              ? "Edit Option Group"
              : "Create a new option group"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="optionGroupName">
              <Form.Label>Option Group Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter option group name..."
                value={optionGroupName}
                onChange={(e) => setOptionGroupName(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="retailerWholesalerSelectOptionGroup">
              <Form.Label>Select Vendor profile</Form.Label>
              <AppSelect block
                value={selectedRetailerWholesalerId}
                onChange={(e) =>
                  setSelectedRetailerWholesalerId(e.target.value)
                }
              >
                <option value="" disabled>
                  Select vendor
                </option>
                {retailersWholesalers.map((retailerWholesaler) => (
                  <option
                    key={retailerWholesaler._id}
                    value={retailerWholesaler.owner}
                  >
                    {retailerWholesaler.name}
                  </option>
                ))}
              </AppSelect>
            </Form.Group>
            <Form.Group controlId="optionSelect">
              <Form.Label>Select Options</Form.Label>
              <Select
                isMulti
                options={options.map((option) => ({
                  value: option._id,
                  label: `${option.name} - ${new Intl.NumberFormat("en-UG", {
                    style: "currency",
                    currency: "UGX",
                  }).format(option.price)}`,
                  mandatory: false,
                }))}
                value={selectedOptions}
                onChange={setSelectedOptions}
                formatOptionLabel={(option, { context }) => (
                  <div className="d-flex justify-content-between align-items-center">
                    <span>{option.label}</span>
                    <Form.Check
                      type="checkbox"
                      checked={selectedOptions.some(
                        (selectedOption) =>
                          selectedOption.value === option.value &&
                          selectedOption.mandatory
                      )}
                      onChange={(e) => {
                        const updatedOptions = selectedOptions.map((opt) =>
                          opt.value === option.value
                            ? { ...opt, mandatory: e.target.checked }
                            : opt
                        );
                        setSelectedOptions(updatedOptions);
                      }}
                      label="Mandatory"
                      className="ml-2"
                    />
                  </div>
                )}
              />
            </Form.Group>
            <Row>
              <Col>
                <Form.Group controlId="minOptions">
                  <Form.Label>Minimum Options</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Enter minimum options..."
                    value={minOptions}
                    onChange={(e) => {
                      const value = parseInt(e.target.value);
                      setMinOptions(value < 0 ? 0 : value);
                    }}
                    min="0"
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="maxOptions">
                  <Form.Label>Maximum Options</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Enter maximum options..."
                    value={maxOptions}
                    onChange={(e) => {
                      const value = parseInt(e.target.value);
                      setMaxOptions(value < 0 ? 0 : value);
                    }}
                    min="0"
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowOptionGroupModal(false)}
          >
            Discard Changes
          </Button>
          <Button variant="success" onClick={handleOptionGroupSubmit}>
            {currentOptionGroupId
              ? "Update Option Group"
              : "Create option group"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for delete confirmation */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this section and all its products?
          This action cannot be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowDeleteModal(false)}
            disabled={isLoadingDeleteOptionGroup}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={confirmDeleteSection}
            disabled={isLoadingDeleteOptionGroup}
            style={{
              cursor: isLoadingDeleteOptionGroup ? "not-allowed" : "pointer",
              color: isLoadingDeleteOptionGroup ? "black" : "white",
            }}
          >
            {isLoadingDeleteOptionGroup ? "Deleting..." : "Delete"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for delete option group confirmation */}
      <Modal
        show={showOptionGroupDeleteModal}
        onHide={() => setShowOptionGroupDeleteModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this option group? This action cannot
          be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowOptionGroupDeleteModal(false)}
            disabled={isLoadingDeleteOptionGroup}
            style={{
              color: isLoadingDeleteOptionGroup ? "black" : "white",
            }}
          >
            Cancel
          </Button>
          <div
            style={{
              cursor: isLoadingDeleteOptionGroup ? "not-allowed" : "pointer",
            }}
          >
            <Button
              variant="danger"
              onClick={confirmDeleteOptionGroup}
              disabled={isLoadingDeleteOptionGroup}
              style={{
                cursor: isLoadingDeleteOptionGroup ? "not-allowed" : "pointer",
                color: isLoadingDeleteOptionGroup ? "black" : "white",
              }}
            >
              {isLoadingDeleteOptionGroup ? "Deleting..." : "Delete"}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Modal for delete option confirmation */}
      <Modal
        show={showOptionDeleteModal}
        onHide={() => setShowOptionDeleteModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this option? This action cannot be
          undone.
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowOptionDeleteModal(false)}
            disabled={isLoadingDeleteOptionGroup}
          >
            Cancel
          </Button>
          <div
            style={{
              cursor: isLoadingDeleteOptionGroup ? "not-allowed" : "pointer",
            }}
          >
            <Button
              variant="danger"
              onClick={confirmDeleteOption}
              disabled={isLoadingDeleteOptionGroup}
              style={{
                cursor: isLoadingDeleteOptionGroup ? "not-allowed" : "pointer",
                color: isLoadingDeleteOptionGroup ? "black" : "white",
              }}
            >
              {isLoadingDeleteOptionGroup ? "Deleting..." : "Delete"}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Modal for editing an option */}
      <Modal
        show={showEditOptionModal}
        onHide={() => setShowEditOptionModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Option</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="editOptionName">
              <Form.Label>Option Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter option name..."
                value={editOptionName}
                onChange={(e) => setEditOptionName(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="editOptionPrice">
              <Form.Label>Option Price</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter option price..."
                value={editOptionPrice}
                onChange={(e) => setEditOptionPrice(parseFloat(e.target.value))}
              />
            </Form.Group>
            <Form.Group controlId="editOptionEnabled">
              <Form.Label>Enabled</Form.Label>
              <Switch
                checked={editOptionEnabled}
                onChange={(e) => setEditOptionEnabled(e.target.checked)}
                color="primary"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowEditOptionModal(false)}
          >
            Cancel
          </Button>
          <Button variant="success" onClick={handleEditOptionSubmit}>
            Save changes
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Floating Image Preview */}
      <style>{`@keyframes rwvm-fadeIn { from { opacity:0; transform:scale(0.92); } to { opacity:1; transform:scale(1); } }`}</style>
      {hoveredImage && (
        <div
          style={{
            position: "fixed",
            left: Math.min(imagePreviewPosition.x, window.innerWidth - 420),
            top: Math.max(20, Math.min(imagePreviewPosition.y, window.innerHeight - 420)),
            zIndex: 9999,
            pointerEvents: "none",
            animation: "rwvm-fadeIn 0.18s ease-out",
          }}
        >
          <div
            style={{
              width: "400px",
              height: "400px",
              borderRadius: "16px",
              overflow: "hidden",
              boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
              border: "4px solid white",
              background: "#f8f9fa",
            }}
          >
            <img
              src={hoveredImage}
              alt="Product preview"
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </div>
        </div>
      )}
    </Col>
  );
};

export default RetailerWholesalerVendorMenu;
